// Popunjavanje obrasca podacima iz sudskog registra.
//
// Isto na sva tri ekrana (ulazni racun, izlazni racun, kasa), da se ne dogodi
// da jedan uzme skraceni naziv a drugi puni.
//
// Jedno pravilo vrijedi svugdje: registar NE prepisuje ono sto vec pise u
// obrascu osim ako se to izricito trazi. Na ulaznom racunu podaci dolaze iz
// eRacuna dobavljaca i oni su mjerodavni - registar samo popuni praznine.

const prazno = (v) =>
  v === undefined || v === null || (typeof v === 'string' && v.trim() === '')

// Polja koja registar zna. Ostalo (IBAN, telefon, kontakt) ne dira - toga u
// sudskom registru nema.
const POLJA = [
  'partnerName',
  'partnerNameShort',
  'partnerStreet',
  'partnerBuildingNameNumber',
  'partnerCity',
  'partnerPostcode',
  'partneremail'
]

/**
 * @param {Object}  cilj    document / mainledger
 * @param {Object}  izvor   partner kakav vraca /sudreg/pooibu
 * @param {boolean} prepisi true = prepisi i popunjena polja
 * @returns {string[]} nazivi polja koja su popunjena
 */
const popuni = (cilj, izvor, prepisi) => {
  if (!cilj || !izvor) { return [] }
  const popunjeno = []
  POLJA.forEach(polje => {
    const nova = izvor[polje]
    if (prazno(nova)) { return }
    if (!prepisi && !prazno(cilj[polje])) { return }
    if (cilj[polje] === nova) { return }
    cilj[polje] = nova
    popunjeno.push(polje)
  })
  // U sudskom registru su samo pravne osobe, pa se kvacica "privatna osoba"
  // skida - ali samo kad je nesto stvarno popunjeno.
  if (popunjeno.length && cilj.privatePerson === true) {
    cilj.privatePerson = false
    popunjeno.push('privatePerson')
  }
  return popunjeno
}

// Kratak opis firme za poruku korisniku: "KOESTLIN d.d. · Bjelovar · d.d."
const opis = (p) => {
  if (!p) { return '' }
  const s = p.sudreg || {}
  return [p.partnerName, p.partnerCity, s.pravniOblikKratica].filter(x => x).join(' · ')
}

export { popuni, opis, POLJA }
